import { render, staticRenderFns } from "./FactorInvoiceView.vue?vue&type=template&id=0fa7d01b"
import script from "./FactorInvoiceView.vue?vue&type=script&lang=js"
export * from "./FactorInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports